// extracted by mini-css-extract-plugin
export default {"assetMapImageMarker":"CustomMarker_assetMapImageMarker__lX-Sm","arrow":"CustomMarker_arrow__wPind"};